import { render, staticRenderFns } from "./CreateSquad.vue?vue&type=template&id=e0628bee"
import script from "./CreateSquad.vue?vue&type=script&lang=js"
export * from "./CreateSquad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports